import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { setCurrentTab, showSideBar, showNavBar } from '../../actions/commonActions'
import { getCertifications } from '../../actions/certificationActions'
import { showGenericError } from '../../utility/certificationBuilder'

import Loader from '../common/loader/Loader'
import PageHeader from '../common/PageHeader/PageHeader'
import CertificationCard from './CertificationCard'
import CertificationFormModal from './CertificationFormModal'

import classes from './CertificationsPage.module.scss'

const CertificationsPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const certifications = useSelector(state => state.certificationBuilder.certifications)
  const [loader, setLoader] = useState(true)
  const [showForm, setShowForm] = useState(false)

  useEffect(() => {
    dispatch(setCurrentTab('Certification'))
    dispatch(showSideBar(true))
    dispatch(showNavBar(true))
  }, [dispatch])

  useEffect(() => {
    dispatch(getCertifications()).unwrap()
      .catch(showGenericError)
      .finally(() => setLoader(false))
  }, [dispatch])

  const addButton = (
    <button className='btn btn-primary text-white pull-right mr-2' onClick={() => setShowForm(true)}>
      <i className='fa fa-plus mr-2' aria-hidden='true' />
      {t('certificationBuilder.list.add')}
    </button>
  )

  return (
    <div id='certificationsPage'>
      <PageHeader title={t('certificationBuilder.page.title')} actionComponent={addButton} />

      <main className={classes.wrapper}>
        {loader ? (
          <div className='h-100 d-flex align-items-center justify-content-center'>
            <Loader>{t('certificationBuilder.list.loading')}</Loader>
          </div>
        ) : (
          <div className={classes.grid}>
            {certifications.map(certification => (
              <CertificationCard key={certification.id} certification={certification} />
            ))}
          </div>
        )}
      </main>

      {showForm && (
        <CertificationFormModal
          isOpen={showForm}
          nextLevel={Math.max(0, ...certifications.map(certification => certification.level)) + 1}
          onClose={() => setShowForm(false)}
          onCreated={(certification) => navigate(`/certifications/${certification.id}`)}
        />
      )}
    </div>
  )
}

export default CertificationsPage
